<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">Настройки</div>

      <div class="panel-body">
        <h4>Настройки оформления заказа</h4>
        <hr>

        <form>
          <div class="row">
            <div class="col-xs-12">
              <div class="form-group">
                <label for="min_order_sum">Минимальная сумма заказа</label>
                <input type="text" id="min_order_sum" class="form-control" v-model="minOrderSum" />
              </div>
              <div class="form-group">
                <label for="free_delivery_sum">Минимальная сумма бесплатной доставки</label>
                <input type="text" id="free_delivery_sum" class="form-control" v-model="freeDeliverySum" />
              </div>
              <div class="form-group">
                Способы доставки

                <label style="display: block;">
                  <input type="checkbox" class="form-control" style="display: inline-block; width: 20px;" v-model="paymentMethod1" :value="1"/>
                  Наличными курьеру при получении
                </label>

                <label style="display: block;">
                  <input type="checkbox" class="form-control" style="display: inline-block; width: 20px;" v-model="paymentMethod2" :value="1"/>
                  Картой курьеру
                </label>

                <label style="display: block;">
                  <input type="checkbox" class="form-control" style="display: inline-block; width: 20px;"  v-model="paymentMethod3" :value="1" />
                  Картой на сайте
                </label>

              </div>
            </div>
          </div>
          <button type="submit" class="btn btn-default" @click.prevent="store()">Сохранить</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {api} from '../http'
var config = require('../config')

export default {
  mounted () {
  },
  data () {
    return {
      url: config.appUrl,
      loaded: false,
      minOrderSum: 0,
      freeDeliverySum: 0,
      paymentMethod1: 0,
      paymentMethod2: 0,
      paymentMethod3: 0
    }
  },
  beforeCreate () {
    this.loaded = false
    api.post('settings/fetchSettings').then(response => {
      this.loaded = true
      this.minOrderSum = response.data.order.minOrderSum
      this.freeDeliverySum = response.data.order.freeDeliverySum
      this.paymentMethod1 = response.data.order.paymentMethod1
      this.paymentMethod2 = response.data.order.paymentMethod2
      this.paymentMethod3 = response.data.order.paymentMethod3
    })
  },
  methods: {
    store () {
      var formData = new FormData()
      console.log(this.data)
      formData.append('minOrderSum', this.minOrderSum)
      formData.append('freeDeliverySum', this.freeDeliverySum)
      formData.append('paymentMethod1', this.paymentMethod1)
      formData.append('paymentMethod2', this.paymentMethod2)
      formData.append('paymentMethod3', this.paymentMethod3)

      api.post('settings/storeSettings', formData).then(response => {
        if (response.data.success) {
          // this.data = response.data
          this.minOrderSum = response.data.order.minOrderSum
          this.freeDeliverySum = response.data.order.freeDeliverySum
          this.paymentMethod1 = response.data.order.paymentMethod1
          this.paymentMethod2 = response.data.order.paymentMethod2
          this.paymentMethod3 = response.data.order.paymentMethod3
        } else {
          // this.modalError = response.data.message
        }
      })
    }
  }
}
</script>

<style>
.image-wrap {
  width: 370px;
  height: 248px;
  background-size: cover;
  border: 1px solid silver;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slider-text {
  width: 450px;
}
</style>



// WEBPACK FOOTER //
// src/components/AdminSettings/AdminSettings.vue